import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  // getProfil: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/tiers/' + numTiers))
  getProfil: () => ApiUtils.responseParser(Axios.get('/web/user/me'))
};
